import { ReactNode } from 'react';
import { Paper, Box, Typography, useTheme } from '@mui/material';

interface DashboardCardProps {
    title: string;
    icon?: ReactNode;
    children: ReactNode;
    actions?: ReactNode;
    noPadding?: boolean;
    accentColor?: 'primary' | 'secondary' | 'success' | 'warning' | 'info';
}

export default function DashboardCard({ 
    title, 
    icon, 
    children, 
    actions, 
    noPadding,
    accentColor = 'primary' 
}: DashboardCardProps) {
    const theme = useTheme();
    
    return (
        <Paper 
            elevation={0}
            sx={{ 
                height: '100%',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Box sx={{ 
                height: 4, 
                bgcolor: theme.palette[accentColor].main 
            }} />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 3,
                    py: 1.5,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    bgcolor: (theme) => `${theme.palette[accentColor].main}10`,
                }}
            >
                {icon && (
                    <Box sx={{ color: `${accentColor}.main` }}>
                        {icon}
                    </Box>
                )}
                <Typography variant="h6" color="text.primary">
                    {title}
                </Typography>
            </Box>
            <Box sx={{ 
                p: noPadding ? 0 : 3,
                flex: 1,
                display: 'flex',
                flexDirection: 'column'
            }}>
                {children}
            </Box>
            {actions && (
                <Box
                    sx={{
                        mt: 'auto',
                        p: 3,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 2
                    }}
                >
                    {actions}
                </Box>
            )}
        </Paper>
    );
} 
